import styled from '@emotion/styled'
import * as React from 'react'
import { Col as Column, Container } from 'react-grid-system'
import { palette } from '../constants'

interface IProps {
  children: React.ReactNode
  className?: string
}

const Grid = (props: IProps) => {
  return (
    <Container fluid xs sm md lg={false} xl={false} className={props.className}>
      {props.children}
    </Container>
  )
}

const Colored = styled.div`
  width: 100%;
  height: 100%;
  background: ${palette.chrome};
`

const Col = (props: any) => {
  const { debug, children, ...rest } = props

  // If debug, fill the cell spcae with background color
  // to highlight the available space vs gutter.
  if (debug) {
    return (
      <Column {...rest}>
        <Colored>{children}</Colored>
      </Column>
    )
  }

  return <Column {...props} />
}

export { Grid, Col }
